export const fmtPrice = (v) => {
  const n = Number(v) || 0;
  if (n >= 1000000) return `$${(n / 1000000).toFixed(n % 1000000 ? 1 : 0)}M`;
  return `$${Math.round(n / 1000)}K`;
};

export const fmtRange = (from, to) => `${fmtPrice(from)} – ${fmtPrice(to)}`;
